module.exports = __webpack_public_path__ + "static/gb-flag-f2e66dcfbb1fce1fadcc6ad7cc61b453.svg";